import React from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { AddToMergeListButton } from "../../../common/components/AddToMergeListButton";
import { MovieItem } from "../MovieItem";

export interface AddToMergeListButtonProps extends ListActionButtonProps {
    movieList: MovieItem[];
    moviesToMerge: MovieItem[];
}

export const AddMovieToMergeListButton: React.FunctionComponent<AddToMergeListButtonProps> = (
    props: AddToMergeListButtonProps
) => {
    const item = props.movieList.find((movie: MovieItem) => movie.id === props.itemId);
    const isButtonDisabled = (): boolean => {
        return (
            props.disabled ||
            props.moviesToMerge.some(
                (movie: MovieItem) => movie.id === item?.id || !movie.buzz?.id === !item?.buzz?.id
            ) ||
            !!item?.merged
        );
    };

    return <AddToMergeListButton disabled={isButtonDisabled()} onClick={props.onClick} />;
};
